module.exports = __webpack_public_path__ + "media/components/LoginModal/travelglobe-f1e8e74616a76b7b3402c18d4af6da54.png";